var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48557 13.2175C9.30901 12.852 11.6667 11.5402 11.6667 8.14828C11.6667 5.06151 9.40724 3.00604 7.78254 2.06158C7.42204 1.852 7 2.12762 7 2.54462V3.61123C7 4.45232 6.64638 5.98756 5.66377 6.62613C5.1621 6.95216 4.6203 6.4642 4.55933 5.86901L4.50927 5.38027C4.45107 4.8121 3.87241 4.46719 3.41831 4.8136C2.60252 5.43592 1.75 6.52568 1.75 8.14828C1.75 12.2964 4.83519 13.3335 6.37776 13.3335C6.46748 13.3335 6.5618 13.3308 6.65998 13.3251C5.89826 13.26 4.66667 12.7874 4.66667 11.2592C4.66667 10.0638 5.53879 9.25504 6.20142 8.86193C6.37962 8.75617 6.58823 8.89349 6.58823 9.10069V9.44439C6.58823 9.70741 6.68996 10.1186 6.9321 10.4001C7.20615 10.7186 7.60836 10.3849 7.64079 9.96601C7.65106 9.83388 7.78394 9.74965 7.89839 9.81656C8.27248 10.0352 8.75 10.5022 8.75 11.2592C8.75 12.4539 8.09142 13.0034 7.48557 13.2175Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.1a267c9a592e14772b1796d69995e94b.svg";
export { ForwardRef as ReactComponent };